module.exports = __webpack_public_path__ + "static/media/banner_slider3.2cbf9ff9.jpg";